<div class="fullscreen-modal" *ngIf="!modalPricingService.hidden()">
    <mat-card class="centered-card">
        <mat-card-header
            style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
            <mat-card-title>Pricing</mat-card-title>
            <button type="button" class="close" style="background:white; border: none; font-size: 30px;"
                data-dismiss="modal" aria-label="Close" (click)="hideModal()">
                <span aria-hidden="true">&times;</span>
            </button>
        </mat-card-header>

        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div class="container">
                        <div style="display: flex; flex-wrap: wrap; justify-content: center;">
                            <!-- Subscriptions Plans -->
                            <div *ngFor="let plan of subscriptionPlans">
                                <div class="box">
                                    <h3>{{plan.title}}</h3>
                                    <p>{{ plan.description | translate }}</p>
                                    <p *ngIf="!plan.rangedPrice" class="price">
                                        {{ userService.user.role === 'ROLE_DISTRIBUTOR_PROFESSIONAL' ?
                                        plan.price.distributor :
                                        plan.price.client }}
                                    </p>
                                    <div *ngIf="plan.rangedPrice" (click)="showPricingDetails(plan.product)">
                                        <p class="price">
                                            {{ userService.user.role === 'ROLE_DISTRIBUTOR_PROFESSIONAL' ?
                                            plan.price.distributor :
                                            plan.price.client }}
                                            <i class="fas fa-question-circle" style="font-size: 15px;"></i>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button *ngIf="hideCardPayment" type="button" mat-raised-button color="primary"
                            class="next-button" (click)="showCardInput()">
                            {{ "Next" | translate }}
                        </button>
                        <div [hidden]="hideCardPayment" style="width: 100%;">
                            <div class="row">
                                <div class="col-md-12 mt-3">
                                    <div class="credit-card">
                                        <h4>Credit card</h4>
                                        <div>
                                            <div #cardInfo></div>
                                            <div class="error" *ngIf="cardError">
                                                {{ cardError }}
                                            </div>
                                        </div>
                                        <br>
                                    </div>
                                </div>
                                <div class="button-container">
                                    <button mat-raised-button color="primary" (click)="createSubscription()"
                                        [disabled]="loadingPayment">
                                        Subscribe
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </mat-card>
</div>
<app-modal-pricing-details [productInput]="selectedProductToViewDetails"></app-modal-pricing-details>